export default class SiteUnload {

    /*
    options:
        unloadTimeout : 1000
        protocols: ["mailto", "tel"]
     */

    constructor(options) {
        if (options === undefined) {
            options = {};
        }
        this.options = {
            unloadTimeout: options.unloadTimeout ? options.unloadTimeout : 300,
            protocols: options.protocols ? options.protocols : ["mailto", "tel"],
        }
        window.addEventListener('load', (e) => {
            this.init();
        });
    }

    init() {
        this.ignore_onbeforeunload = false;

        window.onbeforeunload = () => {
            if (!this.ignore_onbeforeunload) {
                document.getElementById('app').style.opacity = '0';
            }
            this.ignore_onbeforeunload = false;
        };
        this.options.protocols.forEach((v, k) => {
            let elements = document.querySelectorAll(`a[href^=${v}]`);
            elements.forEach((v, k) => {
                v.addEventListener('click', () => {
                    this.unloadPage();
                });
            });
        });

        setTimeout(() => {
            document.getElementById('app').style.opacity = '1';
        }, this.options.unloadTimeout)
    }

    unloadPage() {
        this.ignore_onbeforeunload = true;
    }
}
